<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Ubah Paket Bermain</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-tabs>
              <v-tab>Data Utama</v-tab>
              <v-tab>Bonus dan Gratis Bermain</v-tab>
              <v-tab>Persetujuan</v-tab>

              <v-tab-item :key="1">
                <entrance-package-edit-main-data
                  :entrance-package-id="this.$route.params.id"
                ></entrance-package-edit-main-data>
              </v-tab-item>
              <v-tab-item :key="2">
                <entrance-package-edit-free-attraction
                  :entrance-package-id="this.$route.params.id"
                ></entrance-package-edit-free-attraction>
              </v-tab-item>
              <v-tab-item :key="3">
                <entrance-package-approval
                  :entrance-package-id="this.$route.params.id"
                ></entrance-package-approval>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import EntrancePackageEditMainData from "./EntrancePackageEditMainData.vue";
import EntrancePackageEditFreeAttraction from "./EntrancePackageEditFreeAttraction.vue";
import EntrancePackageApproval from "./EntrancePackageApproval.vue";

export default {
  components: {
    EntrancePackageEditMainData,
    EntrancePackageEditFreeAttraction,
    EntrancePackageApproval
  },
  props: ["success_addition_message"],
  data() {
    return {
      isLoadingFinished: false,
      loadingMessageColor: null,
      errorTimeout: 7000,
      loadingMessage: null
    };
  },
  mounted: function() {
    if (this.$route.params.success_addition_message) {
      this.loadingMessage = this.$route.params.success_addition_message;
      this.isLoadingFinished = true;
      this.loadingMessageColor = "primary";
    }
  }
};
</script>

<style></style>
